import React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import snakeCaseKeys from 'snakecase-keys';
import { sendAlert } from '../../actions/utils';
import companyAnnouncement from './companyAnnouncement';
import CompanyAnnouncementForm from './CompanyAnnouncementForm';
import { createCompanyAnnouncementRequest } from '../../requests/companyAnnouncements';

const CompanyAnnouncementNew = ({ setOnRequest, moreData, setMoreData }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const handleSuccessCreate = () => {
    dispatch(sendAlert({ kind: 'success', message: 'Beneficio creado con éxito' }));
    history.push('/company_announcements');
  };

  const handleFailureRequest = error => {
    const { response } = error;
    dispatch(sendAlert({ kind: 'error', message: response?.data?.message }));
  };

  const handleCreateRequest = (companyAnnouncementValues, setSubmitting) => {
    if (setOnRequest) setOnRequest(true);
    const { image, attachedFile } = companyAnnouncementValues.announcement;
    const myParams = snakeCaseKeys(companyAnnouncementValues);
    myParams.announcement.image = image;
    myParams.announcement.attached_file = attachedFile;

    createCompanyAnnouncementRequest({
      dispatch,
      params: myParams,
      formData: true,
      successCallback: handleSuccessCreate,
      failureCallback: error => {
        setSubmitting(false);
        handleFailureRequest(error);
      },
      callback: () => {
        if (setOnRequest) setOnRequest(false);
        if (setMoreData) setMoreData(!moreData);
      }
    });
  };

  return (
    <CompanyAnnouncementForm companyAnnouncement={companyAnnouncement} action="new" formRequest={handleCreateRequest} />
  );
};

export default CompanyAnnouncementNew;
